// Angular modules
import { Component }          from '@angular/core';

// Ionic modules
import { GoogleAnalytics }    from '@ionic-native/google-analytics';
import { NavController }      from 'ionic-angular';
import { MenuController }     from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';
import { ToastController }    from 'ionic-angular';

// External modules
import { Mixture }            from '../../shared/models/mixture';
import { ApplicationService } from '../../shared/providers/application-service';
import { MoleculeResultPage } from '../molecule-result/molecule-result';
import { TranslateService }   from '@ngx-translate/core';

// Helpers
import { StorageHelper }      from '../../shared/helpers/storage.helper';
import { SynchronizePage } from '../synchronize/synchronize';

@Component({
  selector:     'page-select-molecule',
  templateUrl:  'select-molecule.html',
    providers:  [ApplicationService]
})

export class SelectMoleculePage
{
  mixtures        : Mixture[] = [];
  selectedMixture : Mixture   = null;
  molecules       : string[]  = ["N2", "CO2", "O2", "Ar", "He", "H", "NO"];
  values          : string[]  = [];
  moleculesMap    : any ;
  isDetail        : boolean   = false;
  selectedItem    : string    = '';
  overlayIndex    : number    = 0;
  user            : any       = null;
  waitingLabel    : string    = "Please wait...";
  overlayArray    : string[]  = ['assets/menu_overlay_4.png',
                                 'assets/menu_overlay_5.png',
                                 'assets/menu_overlay_6.png',
                                 'assets/menu_overlay_7.png',
                                 'assets/menu_overlay_8.png',
                                 'assets/menu_overlay_9.png'];

  constructor(public navCtrl            : NavController,
              public loadingCtrl        : LoadingController,
              public toastCtrl          : ToastController,
              public applicationService : ApplicationService,
              public translate          : TranslateService,
              public menuCtrl           : MenuController,
              private analytics  : GoogleAnalytics)
  {

    var context = this;

    context.initTranslations();

    if(StorageHelper.getProducts() === null
      || StorageHelper.getCategories() === null
      || StorageHelper.getProductFamilies() === null
    )
    {
      this.presentToast('You need to synchronize your data before accessing this feature');
      this.navCtrl.push(SynchronizePage);
      return;
    }

    context.user = StorageHelper.getUser();
    context.initMixtures();
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Select Mixture");
  }

  initTranslations()
  {
    var context = this;
    this.translate.get('PLEASE_WAIT').subscribe(
      value => {
        context.waitingLabel = value;
      })
  }

  presentLoading()
  {
    var context = this;
    let loader = this.loadingCtrl.create({
      content: context.waitingLabel
    });
    return loader;
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  initMixtures()
  {
    const loader = this.presentLoading();
    loader.present();

    const mixtures = StorageHelper.getMixtures();
    if(mixtures != null)
      this.mixtures = mixtures;
    else
      this.presentToast("Missing Mixtures, please synchronize before.");

    loader.dismiss();
  }

  backAction()
  {
    if(this.isDetail == true)
    {
      this.isDetail = false;
      return;
    }

    this.navCtrl.pop({animate: false});
  }

  selectMolecule(item)
  {
    if(item == 'N2')
      this.values = ["100","88", "82", "80", "70", "60", "50", "30", "25", "10", "9"];

    if(item == 'CO2')
      this.values = ["100","80", "75", "70", "65", "50", "40", "30", "20", "15", "10"];

    if(item == 'O2')
      this.values = ["100","80", "75", "70", "66", "40", "35", "30", "2", "3"];

    if(item == 'He')
      this.values = ["100","80"];

    if(item == 'Ar')
      this.values = ["100"];

    if(item == 'H ')
      this.values = ["100"];

    if(item == 'NO')
      this.values = ["100"];

    this.isDetail     = true;
    this.selectedItem = item;
  }

  getOverlay()
  {
    if(this.overlayIndex == 5)
      this.overlayIndex = 0;

    this.overlayIndex++;

    return this.overlayArray[this.overlayIndex];
  }

  selectValues(item)
  {
    var equivalent  = this.mixtures.filter((mixt) =>
    {
      if(mixt.N2 == item && this.selectedItem == 'N2')
      return true;

      if(mixt.O2 == item && this.selectedItem == 'O2')
      return true;

      if(mixt.CO2 == item && this.selectedItem == 'CO2')
      return true;

      if(mixt.He == item && this.selectedItem == 'He')
      return true;

      if(mixt.Ar == item && this.selectedItem == 'Ar')
      return true;

      if(mixt.H == item && this.selectedItem == 'H')
      return true;

      if(mixt.NO == item && this.selectedItem == 'NO')
      return true;

      return false;
     })

     var val = item + '% ' + this.selectedItem;

     this.navCtrl.push(MoleculeResultPage,
    {
        equivalent,
        val
     }, {animate: true});
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/select-molecule/select-molecule.ts